import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initConsentOnLoad } from "./components/CookieBanner";

initConsentOnLoad();

createRoot(document.getElementById("root")!).render(<App />);
